import { RefObject, useEffect, useRef } from "react";

type Event = MouseEvent | TouchEvent | PointerEvent;

const useOnClickOutside = <T extends HTMLElement = HTMLElement>(
  ref: RefObject<T | null>,
  handler: (e: Event) => void,
) => {
  const handlerRef = useRef(handler);

  // keep latest handler without re-binding listeners
  useEffect(() => {
    handlerRef.current = handler;
  }, [handler]);

  useEffect(() => {
    const listener = (e: Event) => {
      const el = ref.current;
      const target = e.target;

      if (!el || !(target instanceof Node)) return;
      if (el.contains(target)) return;

      handlerRef.current(e);
    };

    document.addEventListener("pointerdown", listener);

    return () => {
      document.removeEventListener("pointerdown", listener);
    };
  }, [ref]);
};

export default useOnClickOutside;
